export const MCP_INPUT_COLUMN_MAX_PX = 400;
export const MCP_TAG_INPUT_WIDTH = '360px';
export const MCP_TAG_FIELD_HEIGHT = '96px';
export const MCP_TAG_PROMPT_HEIGHT = '140px';
